import React, {useEffect, useState} from 'react';
import './radiogroup.css';

const RadioGroupInput = props => {
    return (
        <label className="radio-tabs__item">
            <input type="checkbox"
                   className="radio-tabs__input"
                   checked={props.isChecked}
                   onChange={(e) => props.changeResultGroup(props.index, props.list, e)}
                   value={props.el.value} />
            <span className="radio-tabs__btn">{props.el.value}</span>
        </label>
    );
};

export default RadioGroupInput;
